"use client";
import React, { useState } from "react";
import { apiSubscribeNewsletter } from "@/apis/page_optimization";
import { apiVerifyCaptcha } from "@/apis/captcha";
import { toast } from "react-toastify";
import { faPaperPlane, FontAwesomeIcon } from "@/constants/icons";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

interface Props {
  companyId: string;
  domain: string;
}

const Newsletter = ({ companyId, domain }: Props) => {
  const [email, setEmail] = useState<string>("");
  const [status, setStatus] = useState<'idle' | 'verifying' | 'sending' | 'failed'>('idle');

  const { executeRecaptcha } = useGoogleReCaptcha();

  const validateEmail = (emailStr: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(emailStr);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error("Please enter an email address", { autoClose: 2000 });
      return;
    }
    if (!validateEmail(email)) {
      toast.error("Please enter a valid email address.", { autoClose: 2000 });
      return;
    }
    if (!executeRecaptcha) {
      toast.error("reCAPTCHA not ready. Please try again.", { autoClose: 2000 });
      return;
    }

    try {
      setStatus('verifying');
      const recaptchaToken = await executeRecaptcha("newsletter_form");
      const captchaRes = await apiVerifyCaptcha(domain, recaptchaToken);

      if (!captchaRes?.verified) {
        setStatus('failed');
        toast.error("Captcha verification failed. Please try again.", { autoClose: 2000 });
        return;
      }

      setStatus('sending');
      const response = await apiSubscribeNewsletter(companyId, email);

      if (response?.status === 200 || response?.status === true || response?.message === "Subscribed successfully") {
        toast.success("Thank you for subscribing!", { autoClose: 2000 });
        setEmail("");
      } else {
        toast.error(response?.message || "You have already subscribed to our newsletter.");
      }
    } catch (error) {
      console.error("Error subscribing:", error);
      toast.error("Something went wrong. Please try again.", { autoClose: 2000 });
    } finally {
      setStatus('idle');
    }
  };

  return (
    <div className="trv-subscribe-nl trv-full-bx py-4">
      <div className="d-flex flex-wrap align-items-center justify-content-between px-4">
        <div className="trv-left-section mb-3 mb-md-0">
          <div className="trv-nl-large-text">
            <span>Subscribe</span> Now!
          </div>
          <div className="trv-nl-title">
            Sign up to searing weekly newsletter to get the latest updates.
          </div>
        </div>

        <div className="trv-nl-section">
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="ftr-nw-form">
              <input
                name="news-letter"
                className="form-control"
                placeholder="Email address..."
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button
                type="submit"
                className="ftr-nw-subcribe-btn d-flex align-items-center justify-content-center"
                disabled={status !== 'idle'}
                aria-label="Subscribe"
              >
                <FontAwesomeIcon icon={faPaperPlane} style={{ width: '16px', height: '16px', color: 'white' }} />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
